import { ColorDynamic } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const PermissionIcon = createSvgIcon(
  'PermissionIcon',
  <>
    <circle
      cx="70"
      cy="70"
      r="68.5"
      stroke={ColorDynamic.Silver400}
      strokeWidth="3"
    />
    <circle
      cx="70"
      cy="70"
      r="62.5"
      stroke={ColorDynamic.Silver400}
      strokeWidth="3"
    />
    <circle
      cx="70"
      cy="70"
      r="56.5"
      stroke={ColorDynamic.Silver400}
      strokeWidth="3"
    />
    <path
      d="M46 66.6992C46 62.928 46 61.0424 47.1716 59.8708C48.3431 58.6992 50.2288 58.6992 54 58.6992H86C89.7712 58.6992 91.6569 58.6992 92.8284 59.8708C94 61.0424 94 62.928 94 66.6992V90.2992C94 94.0704 94 95.9561 92.8284 97.1276C91.6569 98.2992 89.7712 98.2992 86 98.2992H54C50.2288 98.2992 48.3431 98.2992 47.1716 97.1276C46 95.9561 46 94.0705 46 90.2992V66.6992Z"
      fill={ColorDynamic.Silver400}
    />
    <path
      d="M70 33C80.1067 33 88.2997 41.1931 88.2998 51.2998V57.0156C89.1586 57.0329 89.9222 57.0705 90.5889 57.1602C91.8445 57.329 92.9777 57.7004 93.8887 58.6113C94.7996 59.5223 95.171 60.6555 95.3398 61.9111C95.4998 63.1007 95.5001 64.5995 95.5 66.3965V90.2041C95.5001 92.0008 95.4997 93.499 95.3398 94.6885C95.171 95.9441 94.7996 97.0783 93.8887 97.9893C92.9778 98.9 91.8443 99.2716 90.5889 99.4404C89.3993 99.6003 87.9004 99.5997 86.1035 99.5996H53.8965C52.0996 99.5997 50.6007 99.6003 49.4111 99.4404C48.1557 99.2716 47.0222 98.9 46.1113 97.9893C45.2004 97.0783 44.829 95.9441 44.6602 94.6885C44.5003 93.499 44.4999 92.0008 44.5 90.2041V66.3965C44.4999 64.5995 44.5002 63.1007 44.6602 61.9111C44.829 60.6555 45.2004 59.5223 46.1113 58.6113C47.0223 57.7004 48.1555 57.329 49.4111 57.1602C50.0778 57.0705 50.8414 57.0329 51.7002 57.0156V51.2998C51.7003 41.1931 59.8933 33 70 33ZM54 60C52.072 60 50.7766 60.0029 49.8105 60.1328C48.8878 60.2569 48.493 60.4718 48.2324 60.7324C47.9718 60.993 47.7569 61.3878 47.6328 62.3105C47.5029 63.2766 47.5 64.572 47.5 66.5V90.0996C47.5 92.0275 47.503 93.323 47.6328 94.2891C47.7569 95.212 47.9718 95.6075 48.2324 95.8682C48.493 96.1286 48.8881 96.3428 49.8105 96.4668C50.7766 96.5967 52.072 96.5996 54 96.5996H86C87.928 96.5996 89.2234 96.5967 90.1895 96.4668C91.1119 96.3428 91.507 96.1286 91.7676 95.8682C92.0282 95.6075 92.2431 95.212 92.3672 94.2891C92.4971 93.323 92.5 92.0275 92.5 90.0996V66.5C92.5 64.572 92.4971 63.2766 92.3672 62.3105C92.2431 61.3878 92.0282 60.993 91.7676 60.7324C91.507 60.4718 91.1122 60.2569 90.1895 60.1328C89.2234 60.0029 87.928 60 86 60H54ZM70 36C61.5501 36 54.7003 42.8499 54.7002 51.2998V57H85.2998V51.2998C85.2997 42.85 78.4499 36 70 36Z"
      fill={ColorDynamic.Dark100}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.0002 72.1992C68.1777 72.1992 66.7002 73.6767 66.7002 75.4992C66.7002 76.7188 67.361 77.7858 68.3513 78.3587L69.1002 78.7919L69.1002 83.8992C69.1002 84.3963 69.5032 84.7992 70.0002 84.7992C70.4973 84.7992 70.9002 84.3963 70.9002 83.8992L70.9002 78.7919L71.6491 78.3586C72.6394 77.7858 73.3002 76.7188 73.3002 75.4992C73.3002 73.6767 71.8227 72.1992 70.0002 72.1992ZM63.7002 75.4992C63.7002 72.0198 66.5208 69.1992 70.0002 69.1992C73.4796 69.1992 76.3002 72.0198 76.3002 75.4992C76.3002 77.5075 75.36 79.2948 73.9002 80.447L73.9002 83.8992C73.9002 86.0531 72.1542 87.7992 70.0002 87.7992C67.8463 87.7992 66.1002 86.0531 66.1002 83.8992L66.1002 80.4471C64.6405 79.2949 63.7002 77.5075 63.7002 75.4992Z"
      fill={ColorDynamic.Dark100}
    />
  </>,
  {
    viewBox: '0 0 140 140',
    style: { height: '140px', width: '140px', fill: 'none' },
  },
);
